import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import lodashGet from 'lodash/get';

import { toMs } from '../../Helper';
import routeList from '../../Routes/list';
import { useGetOrderDetailsQuery } from '../../RTK/api/orders';
import { isLoggedInSelector } from '../../RTK/user/selectors';
import { setReservationCheckoutData } from '../../RTK/utility';
import { selectOrderDetailsFilter } from '../../RTK/utility/selectors';

const useMyReservationDetails = ({ navigation, route }) => {
  const reservationId = lodashGet(route, 'params.id');
  const isSuccess = lodashGet(route, 'params.success');
  const reservation = lodashGet(route, 'params.reservation');
  const isCheckoutSuccess = [true, 'true'].includes(isSuccess); // string or boolean
  const isReservation = [true, 'true'].includes(reservation); // string or boolean
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const orderDetailsFilter = useSelector(selectOrderDetailsFilter);
  const [pollInterval, setPollInterval] = useState(toMs({ sec: 5 })); // stop polling if order is completed

  const { data, isError, isLoading, isUninitialized } = useGetOrderDetailsQuery(
    {
      data: orderDetailsFilter,
      payload: { id: reservationId },
    },
    { skip: !reservationId, pollingInterval: pollInterval },
  );

  // currently just used on mobile, no go back button on web
  const _goBack = useCallback(() => {
    if (!isLoggedIn) {
      navigation.replace(routeList.AUTH);
    } else if (isCheckoutSuccess) {
      navigation.replace(routeList.RESERVATION, { activeTab: 1 });
    } else {
      navigation.goBack();
    }
  }, [isCheckoutSuccess, isLoggedIn, navigation]);

  useEffect(() => {
    if (isError || data?.status === 'completed') {
      // if order is completed, stop the polling
      setPollInterval(0);
    }
  }, [data?.status, isError, _goBack]);

  useEffect(() => {
    if (isCheckoutSuccess) {
      // after redirecting to this page after successful checkout, clear the checkout data
      dispatch(setReservationCheckoutData(undefined));
    }
  }, [isCheckoutSuccess, dispatch]);

  return {
    data,
    isCheckoutSuccess,
    isError,
    isLoading,
    isReservation,
    isUninitialized,
    goBack: _goBack,
  };
};

export default useMyReservationDetails;
